import React from 'react';
import { TagLabel as ChakraTagLabel, TagLabelProps as ChakraTagLabelProps } from '@chakra-ui/react';

export function TagLabel(props: ChakraTagLabelProps) {
  return <ChakraTagLabel {...props} />;
}
